import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4 5h16v10H4z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
})), 'LaptopWindowsTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LaptopWindowsTwoTone.js
// module id = 4419
// module chunks = 2